<!--弹窗-->
<template>
  <div>
    <transition
      name="fade"
      @after-leave="onMaskLeave"
    >
      <div
        v-if="visible"
        class="mask"
        @click="handleMaskClick"
      />
    </transition>
    <transition
      name="scale-bounce"
      @after-leave="onDialogLeave"
    >
      <div
        v-if="visible"
        class="dialog glass"
        :style="{width:width}"
      >
        <div class="title">
          <div class="text">
            {{ title }}
          </div>
          <div
            v-if="showCloseButton"
            class="icon"
            @click="closeDialog"
          >
            <i class="el-icon-close" />
          </div>
        </div>
        <el-scrollbar
          v-if="scrollable"
          class="dialog-content"
        >
          <slot>
            <div class="default-tip">
              <i
                class="default-tip-icon"
                :class="iconClass+' '+type"
              />
              <span
                v-if="!withHtml"
                class="default-tip-message"
              >{{ message }}</span>
              <span
                v-else
                class="default-tip-message"
                v-html="message"
              />
            </div>
          </slot>
        </el-scrollbar>
        <div
          v-else
          class="dialog-content"
        >
          <slot>
            <div class="default-tip">
              <i
                class="default-tip-icon"
                :class="iconClass+' '+type"
              />
              <span
                v-if="!withHtml"
                class="default-tip-message"
              >{{ message }}</span>
              <span
                v-else
                class="default-tip-message"
                v-html="message"
              />
            </div>
          </slot>
        </div>
        <slot
          v-if="showFooter"
          name="footer"
        >
          <div class="dialog-footer">
            <el-button
              size="small"
              @click="handleCancel"
            >
              {{ cancelButtonText }}
            </el-button>
            <el-button
              size="small"
              type="primary"
              :loading="loading"
              @click="handleConfirm"
            >
              {{ confirmButtonText }}
            </el-button>
          </div>
        </slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SlideDialog",
  model: { // Vue2 自定义 v-model
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    scrollable: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '320px'
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    closeOnClickMask: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    iconClass:{
      type: String,
      default: 'el-icon-info'
    },
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'info'
    },
    confirmButtonText: {
      type: String,
      default: '确 定'
    },
    cancelButtonText: {
      type: String,
      default: '取 消'
    },
    withHtml: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      leaving: { mask: false, dialog: false }, // 标记两个动画是否完成
      loading:false
    }
  },
  computed: {
    visible() {
      return this.modelValue;
    }
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm');
    },
    handleCancel() {
      this.closeDialog();
    },
    handleMaskClick() {
      if (this.closeOnClickMask) {
        this.closeDialog();
      }
    },
    closeDialog() {
      this.$emit("update:modelValue", false);
    },
    onMaskLeave() {
      this.leaving.mask = true;
      this.checkClosed();
    },
    onDialogLeave() {
      this.leaving.dialog = true;
      this.checkClosed();
    },
    checkClosed() {
      if (this.leaving.mask && this.leaving.dialog) {
        // 重置状态
        this.leaving.mask = false;
        this.leaving.dialog = false;
        this.$emit("close"); // 两个动画都结束后才通知外部销毁
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../scss/_colors.scss";
/* 遮罩层 */
.mask {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0,0,0,0.55);
  z-index: 1998;
}

/* 弹窗样式 */
.dialog {
  position: fixed;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 320px;
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.25);
  min-width: 500px;
  z-index: 1999;
}

/* 毛玻璃效果 */
.glass {
  background: white;
  backdrop-filter: blur(18px) saturate(160%);
  -webkit-backdrop-filter: blur(18px) saturate(160%);
  border: 1px solid rgba(255, 255, 255, 0.3);
  .title{
    display: flex;
  }
  .text {
    padding-top: 10px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }
  .icon {
    position: absolute;
    right: 10px;
    color: #000;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    border-radius: 50%;
    margin: 5px;
    cursor: pointer;
  }
  .icon:hover{
    background-color: rgba(255, 255, 255, 0.3);
  }
}

/* 内容区 */
.dialog-content {
  max-height: 80vh;
  padding: 10px 20px 20px 20px;
  .default-tip {
    display: flex;
    align-items: center;
    .warning {
      color: #E6A23C;
    }
    .error {
      color: #F56C6C;
    }
    .info {
      color: var(--primary);
    }
    .default-tip-icon {
      padding: 0 12px;
      font-size: large;
    }
    .default-tip-message {
      font-size: 18px;
    }
  }
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px;
  gap: 10px;
}

::v-deep{
  .el-scrollbar__wrap{
    max-height: 80vh;
  }

  .el-form-item__label {
    color: #606266;
    font-weight: 500;
  }

  .el-input__inner {
    border-radius: 8px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #dcdfe6;
    transition: all 0.3s;

    &:focus {
      border-color: #409EFF;
      box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
    }
  }

  .password-strength-bar {
    height: 100%;
    width: 0;
    transition: all 0.3s ease;
    border-radius: 2px;
  }

  .el-button {
    border-radius: 8px;
    padding: 10px 20px;
    transition: all 0.2s;

    &--primary {
      background: var(--primary);
      border-color: var(--primary);
      box-shadow: 0 2px 6px rgba(64, 158, 255, 0.4);

      &:hover {
        background: var(--primary-light);
        border-color: var(--primary-light);
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(64, 158, 255, 0.4);
      }
    }

    &--default:hover {
      background: #f5f7fa;
      border-color: #c0c4cc;
      transform: translateY(-1px);
    }
  }
}
/* 遮罩淡入淡出 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* 弹窗缩放动画（macOS Dock 风格） */
.scale-bounce-enter-active {
  animation: scaleBounceIn 0.38s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.scale-bounce-leave-active {
  animation: scaleBounceOut 0.25s cubic-bezier(0.55, 0.055, 0.675, 0.19) forwards;
}

/* 弹出动画 */
@keyframes scaleBounceIn {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.72);
  }
  60% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.05);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}

/* 收回动画 */
@keyframes scaleBounceOut {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.72);
  }
}
</style>
